/** @jsx jsx */
import { jsx, Box } from "theme-ui"
import Wave from "components/svgs/wave"
import PropTypes from "prop-types"

const Underline = props => (
  <Box
    {...props}
    sx={{
      display: "inline-block",
      position: "relative",
      ...props.sx,
    }}
  >
    {props.children}
    <Wave
      sx={{
        my: 3,
        mx: "auto",
        width: "auto",
        height: "3rem",
        display: "block",
      }}
    />
  </Box>
)

Underline.propTypes = {
  sx: PropTypes.object,
  children: PropTypes.any,
}

export default Underline
